import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { LayoutSectionView } from '../nodeviews';
export var pluginKey = new PluginKey('layoutResizingPlugin');
export default (function (options, pluginInjectionApi, portalProviderAPI, eventDispatcher) {
  return new SafePlugin({
    key: pluginKey,
    props: {
      nodeViews: {
        layoutSection: function layoutSection(node, view, getPos) {
          return new LayoutSectionView({
            node: node,
            view: view,
            getPos: getPos,
            portalProviderAPI: portalProviderAPI,
            eventDispatcher: eventDispatcher,
            pluginInjectionApi: pluginInjectionApi,
            options: options
          }).init();
        }
      }
    }
  });
});